/**
 * Marker metadata for heavy backfills dispatched via Cloud Run Jobs.
 *
 * The dispatch endpoint `POST /api/v1/ingestion/admin/backfill` returns
 * `{ via: 'cloud-run-jobs', executionName }` immediately after kicking off a
 * heavy backfill. These fields are not currently persisted on the
 * `ingestion_runs` row nor surfaced by the backfill-groups endpoint, so the
 * admin UI infers the dispatch path heuristically. This type exists so callers
 * can intersect it onto richer group/run shapes without modifying the shared
 * `types.ts` (which is concurrently owned by other features).
 */
export interface CloudRunJobBackfillMeta {
  readonly via?: 'cloud-run-jobs';
  readonly executionName?: string;
}

/**
 * Heavy-backfill threshold (in months). Heavy backfills (>= this many months)
 * are routed through Cloud Run Jobs by the backend; lighter ones run inline on
 * the gateway worker pool. Keep this in sync with the backend threshold.
 */
export const CLOUD_RUN_JOB_HEAVY_THRESHOLD_MONTHS = 6;

/**
 * Build the GCP console URL for a Cloud Run Job execution. Only useful when
 * the execution name is known (i.e. immediately after dispatch).
 */
export function cloudRunJobExecutionUrl(executionName: string): string {
  return `https://console.cloud.google.com/run/jobs/executions/details/us-central1/halo-ingestion-backfill/${encodeURIComponent(
    executionName,
  )}?project=growhalo`;
}
